export default "__VITE_ASSET__d5c1c525__"